import React from 'react';
import {EntypoPowerPlug} from 'react-entypo-icons';

export function Electrical({...rest}) {
  return <EntypoPowerPlug style={{fontSize: 35}} {...rest} />;
}
